import { render, staticRenderFns } from "./Objetivo.vue?vue&type=template&id=472f0733&scoped=true"
import script from "./Objetivo.vue?vue&type=script&lang=js"
export * from "./Objetivo.vue?vue&type=script&lang=js"
import style0 from "./Objetivo.vue?vue&type=style&index=0&id=472f0733&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472f0733",
  null
  
)

export default component.exports